module.exports = __webpack_public_path__ + "static/hyperv_32.42a9a222.jpg";